export { VesselSharesStore } from './VesselSharesStore';
import { VesselSharesStore } from './VesselSharesStore';

export default {
    vesselSharesStore: new VesselSharesStore()
};
